import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import BlofinLiveOrderPanel from './BlofinLiveOrderPanel';

export default function BlofinManualOrderPage() {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        '&, & *': { boxSizing: 'border-box' },
        p: { xs: 1.5, md: 3 },
        background: 'linear-gradient(180deg, #efe8dc 0%, #edf3f6 100%)',
        minHeight: '100%',
      }}
    >
      <Stack spacing={{ xs: 1.5, md: 2.5 }} sx={{ width: '100%', maxWidth: 1660, mx: 'auto', minWidth: 0 }}>
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            minWidth: 0,
            p: { xs: 2, md: 3 },
            borderRadius: 5,
            background: 'linear-gradient(135deg, #17323c 0%, #355b63 100%)',
            color: '#f7f3ea',
          }}
        >
          <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={1.5} alignItems={{ md: 'center' }}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="h4" sx={{ fontWeight: 900, overflowWrap: 'anywhere' }}>
                Ordres BloFin
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(247,243,234,0.78)', maxWidth: 900 }}>
                Interface LIVE uniquement. La préparation d’une intention ne déclenche aucun ordre ;
                la confirmation explicite reste requise avant MARKET.
              </Typography>
            </Box>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ alignSelf: { xs: 'stretch', md: 'auto' } }}>
              <Button
                href="/trading/orders"
                variant="outlined"
                sx={{ color: '#f7f3ea', borderColor: 'rgba(247,243,234,0.45)', whiteSpace: 'nowrap' }}
              >
                Ordres crypto
              </Button>
              <Button
                href="/trading/stats"
                variant="contained"
                sx={{ bgcolor: '#f3c65c', color: '#17323c', fontWeight: 800, whiteSpace: 'nowrap', '&:hover': { bgcolor: '#e7b94f' } }}
              >
                Statistiques LIVE
              </Button>
            </Stack>
          </Stack>
        </Paper>

        <BlofinLiveOrderPanel />
      </Stack>
    </Box>
  );
}
